export default __webpack_public_path__ + "static/media/area-52.a5936958.jpg";